import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Form,
  Dropdown,
  DatePicker,
  Divider,
  Select,
  Upload,
  Typography,
  InputNumber,
  Checkbox,
  Table,
  Radio,
  Modal,
  Steps,
  Breadcrumb,
  message,
  Tabs,
} from "antd";
import {
  DoubleRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileAddOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  LinkOutlined,
  PaperClipOutlined,
  EditFilled,
  PhoneOutlined,
  MailOutlined,
  InfoCircleOutlined,
  InfoCircleFilled,
  DownOutlined,
  EyeFilled,
  CheckCircleFilled,
  DownloadOutlined,
  FileOutlined,
  FileFilled,
  MessageFilled,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  ClockCircleOutlined,
  CheckOutlined,
  CiCircleOutlined,
  PayCircleFilled,
  ExclamationOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addEstimateAPI,
  GetClientByIdApi,
  getEstimateByIdAPI,
  SendEmailForQuoteAcceptance,
  previewEstimateAPI,
  GetPartnerClientByIdApi,
  GetClientsByPartnerClientId,
} from "../../Clients/ClientsApi";
import { useForm } from "antd/es/form/Form";
import QuoteTypesEnum from "features/Enums/QuoteTypesEnum";
import ServiceIntervalEnum from "features/Enums/ServiceIntervalEnum";
import { getProductsServicesAPI } from "features/ProductsandServices/ProductsandServicesAPI";
import {
  getSalesTaxAPI,
  getStatusAPI,
  GetLookupListApi,
  getQuoteTypeAPI,
  getServiceIntervalAPI,
  getEmployeeAPI,
  getCompanyListAPI,
  getcompaniesAPI,
  getEmployeesAPI,
  getAddressProvincesAPI,
  getAddressCountriesAPI,
  getAddressListAPI,
  GetPartnerSubClientsApi,
} from "CommonComponents/Lookup/LookupAPI";
import { render } from "@testing-library/react";
import { FormattedMessage, useIntl } from "react-intl";
import DiscountTypeEnum from "features/Enums/DiscountTypeEnum";
import StatusEnum from "features/Enums/StatusEnum";
import Address from "CommonComponents/Address";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
import ProductServiceTable from "../../Clients/Quotes/ProductServiceTable";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import {
  getAttachments,
  uploadAttachment,
} from "CommonComponents/Attachments/AttachmentsAPI";
import QuoteAddress from "../../Clients/Quotes/InvoiceQuoteAddress";
import SendEmailModal from "../../Clients/Quotes/SendEmailModal";
import {
  addFile,
  resetAttachments,
  setAttachments,
} from "CommonComponents/Attachments/AttachmentsSlice";
import AddressType from "features/Enums/AddressType";
import { GetLeadByIdApi } from "features/Leads/LeadsAPI";
import { resetPartnerSubClients } from "CommonComponents/Lookup/LookupSlice";

function ViewInvoice() {
  const { TextArea } = Input;
  const { Option } = Select;
  const { Text } = Typography;
  const { Step } = Steps;
  const { Dragger } = Upload;
  const dateFormat = "DD/MM/YYYY";
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const location = useLocation();
  const { leadId } = location?.state || {};
  const { Column } = Table;
  const intl = useIntl();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const quoteTypeId = Form.useWatch("quoteTypeId", form);
  const serviceIntervalId = Form.useWatch("serviceIntervalId", form);
  const { clientId, estimateId, partnerId } = useParams();
  const companyId = localStorage.getItem("CompanyId");
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isRecordPaymentModalVisible, setIsRecordPaymentModalVisible] =
    useState(false);
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "Quotations"
  )?.id;
  const attachmentsFromFiles = useSelector(
    (state) => state.Attachments.attachments
  );
  const fileTypeId = Object.values(FormType).find(
    (f) => f.name === "LeadFiles"
  )?.id;

  useEffect(() => {
    if (leadId && fileTypeId) {
      dispatch(getAttachments(leadId, fileTypeId));
    }

    const leadFilesGroup = attachmentsFromFiles?.[fileTypeId]?.[leadId];

    if (
      fileTypeId === FormType.LeadFiles?.id &&
      leadFilesGroup &&
      !attachmentsFromFiles?.[formTypeId]?.[estimateId] &&
      Array.isArray(leadFilesGroup.documents) &&
      leadFilesGroup.documents.length > 0 &&
      formTypeId
    ) {
      const documents = leadFilesGroup.documents.filter(
        (doc) => !doc.isThumbnail
      );

      const mapped = documents.map((doc, i) => ({
        uid: doc.guidFileName || `existing-${i}`,
        name: doc.originalFileName || `file-${i + 1}`,
        status: "done",
        url: `data:application/octet-stream;base64,${doc.base64Content}`,
        isExisting: true,
        id: doc.id,
      }));

      const quotationStructure = {
        [formTypeId]: {
          [estimateId]: {
            documents: leadFilesGroup.documents,
            formId: estimateId,
            formTypeId: formTypeId,
          },
        },
      };

      dispatch(setAttachments(quotationStructure));

      mapped.forEach((file, index) => {
        dispatch(
          addFile({
            fileName: file.name,
            base64: documents[index]?.base64Content,
            identifier: formTypeId,
            id: null,
          })
        );
      });

      setFileList(mapped);
    }
  }, [
    leadId,
    estimateId,
    fileTypeId,
    formTypeId,
    attachmentsFromFiles,
    dispatch,
  ]);

  const hostURL = process.env.REACT_APP_HOST_URL;
  const token = localStorage.getItem("token_bearer");
  //const [client, setClient] = useState(null);
  const clients = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const ClientsList = useSelector((state) => state.clients.clientsList);
  const partnerSubClients = useSelector(
    (state) => state.lookup.partnerSubClients
  );
  const addressList = useSelector((state) => state.lookup.addressList);
  const estimatesList = useSelector((state) => state.clients.estimatesList);
  const taxList = useSelector((state) => state.lookup.salesTaxList);
  const estimateDetails = useSelector((state) => state.clients.estimateById);
  const companyName = useSelector((state) => state.lookup.companies);
  const companyServices = useSelector(
    (state) => state.lookup.lookupData[LookupTypeEnum.CompanyService.id]
  );
  const leadById = useSelector((state) => state.leads.leadRecordById);
  const quoteTypes = useSelector((state) => state.lookup.quoteTypes);
  const intervals = useSelector((state) => state.lookup.intervals);
  const employeeList = useSelector((state) => state.lookup.employeesList);
  const estimateAttachments = useSelector(
    (state) => state.clients.estimateAttachments
  );
  const [selectedProductss, setSelectedProductss] = useState([
    {
      key: 1,
      productId: null,
      name: "",
      description: "",
      quantity: 1,
      unitPrice: null,
      discount: 0,
      tax: null,
    },
  ]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [formInitialvalues, setFormInitialvalues] = useState();
  const [discount, setDiscount] = useState(0);
  const [selectedTax, setSelectedTax] = useState(null);
  const [isUploadRequired, setIsUploadRequired] = useState(false);
  const [discountType, setDiscountType] = useState(1);
  const [formattedSubTotal, setFormattedSubTotal] = useState("0.00");
  const [formattedGrandTotal, setFormattedGrandTotal] = useState("0.00");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [valueAddress, setValueAddress] = useState(1);
  const [estimateDate, setEstimateDate] = useState(dayjs());
  const [selectedTaxId, setSelectedTaxId] = useState(null);
  const [selectedTaxPercentage, setSelectedTaxPercentage] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [addressType, setAddressType] = useState("");
  //const [selectedAddressType, setSelectedAddressType] = useState(); // This holds 1, 2, or 3
  const [selectedBillingId, setSelectedBillingId] = useState(null);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [depositAmount, setDepositAmount] = useState(0);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [isModalBillOpen, setIsModalBillOpen] = useState(false);
  const [selectedPartnerClientId, setSelectedPartnerClientId] = useState(null);
  const [isPartnerScreen, setIsPartnerScreen] = useState(false);
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [editingSalesPerson, setEditingSalesPerson] = useState(false);
  const [isRefundModalVisible, setIsRefundModalVisible] = useState(false);
  const [isRefundProcessing, setIsRefundProcessing] = useState(false);
  const [refundForm] = Form.useForm();
  const [activeTab, setActiveTab] = useState("1");
  const openRefundModal = () => {
    setIsRefundModalVisible(true);
  };

  const closeRefundModal = () => {
    refundForm.resetFields();
    setIsRefundModalVisible(false);
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const handleRefundSubmit = async () => {
    try {
      const values = await refundForm.validateFields();
      setIsRefundProcessing(true);

      // Simulate processing
      setTimeout(() => {
        message.success(`Refund of $${values.amount} processed successfully`);
        setIsRefundProcessing(false);
        closeRefundModal();
      }, 1000);
    } catch (error) {
      console.error("Refund validation failed:", error);
    }
  };
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded((prev) => !prev);
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const isQuillContentEmpty = (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent.trim() === "";
  };
  const columns1 = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Reference",
      dataIndex: "reference",
      key: "reference",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => <span style={{ color: "green" }}>{amount}</span>,
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
    },
    {
      title: "Refund",
      dataIndex: "refund",
      key: "refund",
      render: (refund) => <span style={{ color: "red" }}>{refund}</span>,
    },
    {
      title: "Refund Notes",
      dataIndex: "refundnotes",
      key: "refundnotes",
    },
  ];

  const data1 = [
    {
      key: "1",
      date: "June 17, 2025",
      type: "Ventilation - Ncr",
      reference: "NC-5",
      amount: "$2000.00",
      discount: "0.00",
      refund: null,
      refundnotes: null,
    },
    {
      key: "2",
      date: "June 19, 2025",
      type: "Ventilation - Ncr",
      reference: "NC-5",
      amount: null,
      discount: "0.00",
      refund: "$2000.00",
      refundnotes: "Client not satisfied with service",
    },
  ];

  const showRecordPaymentModal = () => {
    setIsRecordPaymentModalVisible(true);
    form.setFieldsValue({
      outstanding: 129.35,
      amountReceived: 129.35,
      discount: 0.0,
      newOutstanding: 0.0,
      paymentDate: null,
    });
  };

  const handleRecordPaymentOk = () => {
    form.validateFields().then((values) => {
      console.log("Payment Data:", values);
      setIsRecordPaymentModalVisible(false);
    });
  };

  const handleRecordPaymentCancel = () => {
    setIsRecordPaymentModalVisible(false);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const showModal1 = () => {
    setIsModalOpen1(true);
  };
  const handleCancel1 = () => setIsModalOpen1(false);
  const showBillModal = () => {
    setIsModalBillOpen(true);
  };
  const handleBillOk = () => {
    setIsModalBillOpen(false);
  };
  const handleBillCancel = () => {
    setIsModalBillOpen(false);
  };
  const openAddressModal = (type) => {
    setAddressType(type); // 'billing' or 'shipping'
    setIsAddressModalOpen(true);
  };

  const handleAddressCancel = () => {
    setIsAddressModalOpen(false);
    setAddressType("");
  };
  const selectedCompany = companyName?.items?.find(
    (company) => company?.id === parseInt(companyId)
  );
  const [selected, setSelected] = useState("Paid");
  const statusMap = {
    Unpaid: { color: "#FC0027", label: "Unpaid" }, // Red
    Paid: { color: "#5CB85C", label: "Paid" }, // Green
  };
  const items1 = Object.keys(statusMap).map((statusKey, index) => ({
    key: String(index),
    label: (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setSelected(statusKey);
        }}
      >
        {statusKey}
      </a>
    ),
  }));
  const input = {
    pageNo: null,
    pageSize: null,
    searchQuery: "",
  };
  useEffect(() => {
    //dispatch(getProductsServicesAPI(input));
    dispatch(GetLookupListApi(LookupTypeEnum?.CompanyService?.id, input));
    dispatch(getQuoteTypeAPI());
    dispatch(getServiceIntervalAPI());
    dispatch(getEmployeesAPI());
    dispatch(getCompanyListAPI(input));
    dispatch(getStatusAPI());
    dispatch(getSalesTaxAPI());
    dispatch(getAddressProvincesAPI());
    dispatch(getAddressCountriesAPI());
    if (leadId) {
      dispatch(GetLeadByIdApi(leadId));
    }
  }, []);

  useEffect(() => {
    if (clientId && partnerId) {
      dispatch(GetClientByIdApi(clientId));
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else if (clientId) {
      dispatch(GetClientByIdApi(clientId));
    } else if (partnerId) {
      dispatch(GetPartnerClientByIdApi(partnerId));
    }
    if (estimateId) {
      dispatch(getEstimateByIdAPI(estimateId));
    }
  }, [clientId, estimateId, partnerId]);

  useEffect(() => {
    if (clientSearchTerm != "") {
      dispatch(GetPartnerSubClientsApi(partnerId, clientSearchTerm));
    }
    dispatch(resetPartnerSubClients());
  }, [clientSearchTerm]);

  useEffect(() => {
    if (clientId && !partnerId && clients && !estimateDetails) {
      const billing = clients?.address?.find((a) => a.addressType === 2);
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      setBillingAddress(billing);
      setShippingAddress(shipping);
      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
      });
    } else if (
      !clientId &&
      partnerId &&
      partner &&
      !selectedPartnerClientId &&
      !estimateDetails
    ) {
      const billing = partner?.address?.find((a) => a.addressType === 2);
      setIsPartnerScreen(true);
      setBillingAddress(billing);
    } else if (
      clientId &&
      partnerId &&
      clients &&
      partner &&
      !estimateDetails
    ) {
      const billing = partner?.address?.find((a) => a.addressType === 2);
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      setBillingAddress(billing);
      setShippingAddress(shipping);
      setIsPartnerScreen(false);
      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
      });
    } else if (estimateDetails) {
      setIsPartnerScreen(false);
      const missingAddressIds = [];
      if (partner) {
        const billingAddress = partner?.address.find(
          (addr) => addr.id === estimateDetails?.billingAddressId
        );
        setBillingAddress(billingAddress);
        setSelectedPartnerClientId(estimateDetails?.clientId);
      } else {
        form.setFieldsValue({
          clientName: clients?.isResidential
            ? clients?.name
            : clients?.companyName,
        });
        const billingAddress = clients?.address.find(
          (addr) => addr.id === estimateDetails?.billingAddressId
        );

        const shippingAddress = clients?.address.find(
          (addr) => addr.id === estimateDetails?.addressId
        );
        if (billingAddress) {
          setBillingAddress(billingAddress);
        } else {
          missingAddressIds.push(estimateDetails.billingAddressId);
        }

        if (shippingAddress) {
          setShippingAddress(shippingAddress);
        } else {
          missingAddressIds.push(estimateDetails.addressId);
        }

        if (!billingAddress || !shippingAddress) {
          dispatch(getAddressListAPI(missingAddressIds));
        }
      }
    }
  }, [clients, partner, estimateDetails]);

  useEffect(() => {
    if (selectedPartnerClientId && estimateDetails) {
      const shipping = clients?.address?.find(
        (a) => a.id === estimateDetails?.addressId
      );
      if (shipping) {
        setShippingAddress(shipping);
      } else if (
        !shipping &&
        estimateDetails?.clientId != selectedPartnerClientId
      ) {
        const shipping = clients?.address?.find((a) => a.addressType === 1);

        setShippingAddress(shipping);
      } else {
        dispatch(getAddressListAPI([estimateDetails?.addressId]));
      }

      form.setFieldsValue({
        clientName: clients?.isResidential
          ? clients?.name
          : clients?.companyName,
      });
    } else if (selectedPartnerClientId) {
      const shipping = clients?.address?.find((a) => a.addressType === 1);

      setShippingAddress(shipping);
    }
  }, [clients]);

  useEffect(() => {
    if (selectedPartnerClientId) {
      dispatch(GetClientByIdApi(selectedPartnerClientId));
    }
  }, [selectedPartnerClientId]);

  useEffect(() => {
    if (billingAddress) {
      setSelectedBillingId(billingAddress?.id);
    }
  }, [billingAddress]);
  useEffect(() => {
    if (shippingAddress) {
      setSelectedShippingId(shippingAddress?.id);
    }
  }, [shippingAddress]);

  useEffect(() => {
    if (addressList) {
      const billing = addressList?.find(
        (addr) => addr.id === estimateDetails?.billingAddressId
      );
      const shipping = addressList?.find(
        (addr) => addr.id === estimateDetails?.addressId
      );

      if (billing) {
        setBillingAddress(billing);
      }

      if (shipping) {
        setShippingAddress(shipping);
      }
    }
  }, [addressList]);

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr.address1,
      addr.address2,
      addr.city,
      provinceName,
      countryName,
      addr.zip,
    ].filter(Boolean);

    return parts.join(", ");
  };

  useEffect(() => {
    if (selectedProductss.length == 0) {
      setDiscount(0);
      setDiscountType(1);
    }
  }, [selectedProductss]);

  const handleTaxChange = (value, option) => {
    if (!value) {
      setSelectedTaxId(null);
      setSelectedTaxPercentage(null);
      setSelectedTax(null);
      return;
    }
    const taxObject = taxList.find((tax) => tax?.id === value);
    if (taxObject) {
      setSelectedTaxId(taxObject?.id);
      setSelectedTaxPercentage(taxObject?.taxPercentage);
      setSelectedTax(taxObject?.taxPercentage);
    }
  };
  const getSubTotal = () => {
    if (estimateDetails && !selectedProductss.length) {
      return estimateDetails.totalCost || 0;
    }
    return selectedProductss.reduce((sum, product) => {
      const amount = Number(product.amount) || 0;
      return sum + amount;
    }, 0);
  };

  const getTaxAmount = () => {
    if (!selectedTaxPercentage) return 0;

    const subTotal = getSubTotal();
    return (subTotal * selectedTaxPercentage) / 100;
  };

  const getGrandTotal = () => {
    if (quoteTypeId === QuoteTypesEnum.Warranty?.id) {
      return 0;
    }
    if (estimateDetails && !selectedProductss.length && !selectedTax) {
      return estimateDetails.grandTotal || 0;
    }
    return getSubTotal() + getTaxAmount();
  };
  useEffect(() => {
    const subTotal = getSubTotal();
    const grandTotal = getGrandTotal();

    setFormattedSubTotal(
      subTotal.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
    setFormattedGrandTotal(
      grandTotal.toLocaleString("en-CA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }, [selectedProductss, selectedTaxPercentage, selectedTax, quoteTypeId]);

  useEffect(() => {
    if (taxList?.length > 0 && selectedTaxId === null) {
      const defaultTax = taxList.find((tax) => tax.id === 6);
      if (defaultTax) {
        setSelectedTaxId(defaultTax.id);
        setSelectedTaxPercentage(defaultTax.taxPercentage);
        setSelectedTax(defaultTax.taxPercentage);
      }
    }
  }, [taxList]);

  const constructEstimateObject = async (emailData = null) => {
    try {
      const values = await form.validateFields();
      const grandTotal =
        quoteTypeId === QuoteTypesEnum.Warranty?.id ? 0 : getGrandTotal();
      const estimateDate = values.estimateDate
        ? dayjs(values.estimateDate).format("YYYY-MM-DD")
        : null;
      const expiryDate = values.expiryDate
        ? dayjs(values.expiryDate).format("YYYY-MM-DD")
        : null;
      const contractStartDate = values.contractStartDate
        ? dayjs(values.contractStartDate).format("YYYY-MM-DD")
        : null;

      const estimateObject = {
        Id: estimateId ? estimateDetails?.id : 0,
        CompanyId: companyId,
        ClientId: clients?.id,
        AddressId: selectedShippingId,
        BillingAddressId: selectedBillingId,
        EstimateDate: estimateDate,
        ExpiryDate: expiryDate,
        TotalCost: parseFloat(formattedSubTotal.replace(/,/g, "")),
        TotalDiscount: discount,
        TotalTax: getTaxAmount(),
        TaxId: selectedTaxId,
        TaxPercentage: selectedTax || 0,
        GrandTotal: grandTotal.toFixed(2),
        Notes: values.notes,
        TermsAndConditions: values.termsAndConditions,
        EstimateStatusId: StatusEnum.Draft?.id,
        PONumber: values.ponumber,
        DiscountType: discountType,
        SalesPersonId: values.salesPersonId,
        Deposit: depositAmount,
        companyServiceId: values.companyServiceId,
        QuoteTypeId: values.quoteTypeId,
        ServiceIntervalId: values.serviceIntervalId,
        ContractStartDate: contractStartDate,
        EndOccurances: values.endOccurances,
        IntervalInMonths: values.intervalInMonths,
        IntervalInYears: values.intervalInYears,
        LeadId: leadById?.id || null,
        EstimateItems: selectedProductss
          .filter((product) => product.productId)
          .map((product) => ({
            Id: estimateId ? product.key : 0,
            EstimateId: estimateId ? estimateDetails?.id : 0,
            ProductServiceId: product.productId,
            Name: product.name,
            Quanity: product.quantity,
            Rate: product.unitPrice,
            Discount: product.discount,
            Amount: product.amount,
            ClassId: null,
          })),
        BillingAddress: selectedBillingId ? null : billingAddress,
        shippingAddress: selectedShippingId ? null : shippingAddress,
        PartnerId: partnerId ? partnerId : null,
      };

      if (emailData) {
        var input = {
          estimate: estimateObject,
        };
        input.Email = {
          EstimateId: estimateId ? estimateDetails?.id : 0,
          EstimateStatusId: StatusEnum.Submitted?.id,
          To: values.email
            ? values.email.split(",").map((e) => e.trim())
            : [""],
          Cc: values.cc ? values.cc.split(",").map((e) => e.trim()) : [""],
          Subject: values.subject || "",
          Message: values.message || "",
          IncludedAttachment: values.includedAttachment ?? true,
        };
        return input;
      }

      return estimateObject;
    } catch (error) {
      console.log("Error in constructing estimate object:", error);
      throw error;
    }
  };
  const handleUpsertEstimate = async (checked) => {
    try {
      const estimateInfo = await constructEstimateObject();
      if (!estimateInfo || estimateInfo.EstimateItems?.length === 0) {
        OpenNotificationWithIcon(
          "warning",
          "Common.Warning",
          "",
          "Quote.Error.ProductServiceTable"
        );
        return;
      }
      dispatch(addEstimateAPI(estimateInfo, companyId)).then((res) => {
        if (res) {
          dispatch(uploadAttachment(res));
          setSelectedProductss((prev) => prev.filter((item) => item.productId));

          setIsUploadRequired(checked);
          const url =
            partnerId && clientId
              ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
              : clientId
              ? `/${companyId}/${clientId}/client_details`
              : `/${companyId}/${partnerId}/partner_client_details`;

          navigate(url);
          setSelectedPartnerClientId(null);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitQuoteAndSendEmail = async (emailData) => {
    try {
      await form.validateFields();
      const estimateInfo = await constructEstimateObject(emailData);
      if (!estimateInfo || estimateInfo.estimate?.EstimateItems?.length === 0) {
        OpenNotificationWithIcon(
          "warning",
          "Common.Warning",
          "",
          "Quote.Error.ProductServiceTable"
        );
        return;
      }
      const { estimate, ...inputWithoutEstimate } = estimateInfo;
      estimateInfo.estimate.EstimateStatusId = StatusEnum.Submitted?.id;
      dispatch(addEstimateAPI(estimateInfo?.estimate, companyId)).then(
        async (res) => {
          if (res) {
            await dispatch(uploadAttachment(res));
            inputWithoutEstimate.Email.EstimateId = res;
            dispatch(SendEmailForQuoteAcceptance(inputWithoutEstimate.Email));
            const url =
              partnerId && clientId
                ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
                : clientId
                ? `/${companyId}/${clientId}/client_details`
                : `/${companyId}/${partnerId}/partner_client_details`;

            navigate(url);
            setSelectedPartnerClientId(null);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const totalColumns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => {
        if (["1", "4", "5"].includes(record.key)) {
          return {
            children: text,
            props: { colSpan: 2 },
          };
        }
        return text;
      },
    },
    {
      title: "discountinput",
      dataIndex: "discountinput",
      key: "discountinput",
      width: 190,
      render: (text, record) => {
        if (["1", "4", "5"].includes(record.key)) {
          return { children: null, props: { colSpan: 0 } };
        }
        if (record.key === "2") {
          return <p>TPS/TVQ QC 14.975%</p>;
        } else if (record.key === "3") {
          return <p>TPS/TVQ QC 14.975%</p>;
        }
        return text;
      },
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      align: "right",
      width: 130,
    },
  ];
  const data = [
    {
      key: "1",
      description: <FormattedMessage id="AddEstimate.SubTotal" />,
      value: `$1945.00`,
    },
    {
      key: "3",
      description: <FormattedMessage id="AddEstimate.TotalTax" />,
      value: "$545.00",
    },
    {
      key: "4",
      description: <FormattedMessage id="AddEstimate.GrandTotal" />,
      value: `$2490.00`,
      className: "total-row",
    },
    {
      key: "5",
      description: (
        <div>
          <FormattedMessage id="Quote.DepositAmount" />
          <div style={{ fontSize: 10, color: "#faad14", marginTop: 2 }}>
            * Deposit amount can't be more than grand total
          </div>
        </div>
      ),
      value: (
        <>
          <p>0</p>
        </>
      ),
    },
  ];
  const columns = [
    { title: "Product name", dataIndex: "productName" },
    { title: "Description", dataIndex: "description" },
    { title: "Quantity", dataIndex: "quantity" },
    { title: "Unit price", dataIndex: "unitPrice" },
    { title: "Discount", dataIndex: "discount" },
    { title: "Amount", dataIndex: "amount" },
  ];

  const dataSource = [
    {
      key: 0,
      productName: "Panel",
      description: "Panel structure 5Kva",
      quantity: 1,
      unitPrice: "$1725.00",
      discount: "$0.00",
      amount: "$1725.00",
    },
    {
      key: 1,
      productName: "Panel Board",
      description: "this is for panel installation.",
      quantity: 2,
      unitPrice: "$110.00",
      discount: "$0.00",
      amount: "$220.00",
    },
  ];

  useEffect(() => {
    if (estimateDetails) {
      const estimateDate = estimateDetails?.estimateDate
        ? dayjs(estimateDetails?.estimateDate, "YYYY-MM-DD")
        : null;
      const expiryDate = estimateDetails?.expiryDate
        ? dayjs(estimateDetails?.expiryDate, "YYYY-MM-DD")
        : null;
      const contractStartDate = estimateDetails?.contractStartDate
        ? dayjs(estimateDetails?.contractStartDate, "YYYY-MM-DD")
        : null;
      const addressIdExists = clients?.address?.some(
        (addr) => addr.addressId === estimateDetails?.addressId
      );
      const billingAddressIdExists = clients?.address?.some(
        (addr) => addr.addressId === estimateDetails?.billingAddressId
      );
      const taxObject = taxList?.find(
        (tax) => tax.id === estimateDetails?.taxId
      );
      if (taxObject) {
        setSelectedTaxId(taxObject?.id);
        setSelectedTaxPercentage(taxObject?.taxPercentage);
        setSelectedTax(taxObject?.taxPercentage);
      } else if (estimateDetails.taxPercentage) {
        setSelectedTaxId(estimateDetails?.taxId);
        setSelectedTaxPercentage(estimateDetails?.taxPercentage);
        setSelectedTax(estimateDetails?.taxPercentage);
      }
      if (estimateDetails.taxPercentage) {
        setSelectedTax(estimateDetails?.taxPercentage);
      }
      if (estimateDetails.deposit) {
        setDepositAmount(estimateDetails.deposit);
      }
      setFormattedSubTotal(
        estimateDetails.totalCost.toLocaleString("en-CA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );

      setFormattedGrandTotal(
        estimateDetails.grandTotal.toLocaleString("en-CA", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );

      form.setFieldsValue({
        ...estimateDetails,
        estimateDate,
        expiryDate,
        contractStartDate,
        status: estimateDetails?.estimateStatusId,
        addressId: addressIdExists ? estimateDetails?.addressId : null,
        billingAddressId: billingAddressIdExists
          ? estimateDetails?.billingAddressId
          : null,
        deposit: estimateDetails.deposit,
        taxPercentage: estimateDetails.taxPercentage,
        salesPersonId: estimateDetails?.salesPersonId,
      });

      setDiscount(estimateDetails?.totalDiscount);
      setDiscountType(estimateDetails?.discountType || 1);
      setSelectedTax(estimateDetails?.totalTax);
      const filesAvailable = estimateAttachments?.length > 0;
      if (filesAvailable) {
        setIsUploadRequired(true);
      }
      if (estimateDetails?.estimateItems) {
        const initialProducts = estimateDetails?.estimateItems.map((item) => ({
          key: item.id,
          productServiceId: item.productServiceId,
          name: item.productServiceName,
          description: item.description,
          quantity: item.quantity,
          unitPrice: item.rate,
          discount: item.discount,
          amount: item.amount,
        }));
        setSelectedProducts(initialProducts);
      }
    }
  }, [estimateDetails, form]);
  useEffect(() => {
    if (selectedCompany?.termsAndConditions) {
      form.setFieldsValue({
        termsAndConditions: selectedCompany.termsAndConditions,
      });
    }
    if (estimateDate) {
      const expiry = estimateDate.clone().add(1, "month");
      form.setFieldsValue({ expiryDate: expiry });
    }
    if (leadId && leadById) {
      form.setFieldsValue({
        companyServiceId: leadById.companyServiceId,
      });
    }
    if (
      leadById &&
      employeeList?.some((emp) => emp.id === leadById.responsibleId)
    ) {
      form.setFieldsValue({
        salesPersonId: leadById.responsibleId,
      });
    }
  }, [selectedCompany, estimateDate, leadById, employeeList, form]);
  useEffect(() => {
    if (quoteTypeId === QuoteTypesEnum.Warranty?.id) {
      setFormattedGrandTotal("0.00");
    } else if (quoteTypeId === QuoteTypesEnum.PreventiveMaintenance?.id) {
      if (formattedGrandTotal === "0.00") {
        const subTotal = getSubTotal();
        const grandTotal =
          subTotal + (subTotal * (selectedTaxPercentage || 0)) / 100;
        setFormattedGrandTotal(
          grandTotal.toLocaleString("en-CA", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      }
    }
  }, [quoteTypeId, getSubTotal]);

  const resetFormAndState = () => {
    form.resetFields();
    form.setFieldsValue({
      estimateDate: dayjs(),
      contractStartDate: dayjs(),
    });
    setEstimateDate(dayjs());
    setSelectedProducts([]);
    setDiscount(0);
    setDiscountType(1);
    setSelectedTax(null);
    setSelectedTaxId(null);
    setSelectedTaxPercentage(null);
    setFormattedSubTotal("0.00");
    setFormattedGrandTotal("0.00");
    setDepositAmount(0);
    setFileList([]);
    setIsUploadRequired(false);
  };
  useEffect(() => {
    if (!estimateId) {
      resetFormAndState();
    }
  }, [estimateId, form]);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const items = [
    {
      key: "1",
      label: (
        <Space direction="vertical">
          <div>
            <PhoneOutlined />
            &nbsp;&nbsp; 2143240000
          </div>
          <div>
            <MailOutlined />
            &nbsp;&nbsp; Nehra@gmail.com
          </div>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle" justify="space-between">
              <Col>
                <h4>View Invoice (INV1245)</h4>
                <p className="mt-5px">View, edit or manage your Sales Quote.</p>
              </Col>
              <Col>
                <Space>
                  <Breadcrumb
                    separator={<DoubleRightOutlined />}
                    items={[
                      {
                        title: (
                          <FormattedMessage id="ClientDetails.ClientDetails" />
                        ),
                        href: `/2/64/client_details`,
                      },

                      {
                        title: (
                          <FormattedMessage id="WorkOrderDetails.WorkOrderDetails" />
                        ),
                        href: `2/64/client_details/wo_details/48`,
                      },
                      {
                        title: "View Invoice",
                      },
                    ]}
                  />
                </Space>
              </Col>
            </Row>
          </div>
          <Row gutter={[16, 16]} className="viewquote-new addestimate">
            <Col span={18}>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                initialValues={formInitialvalues}
                autoComplete="off"
                size="large"
              >
                <Card bordered={false}>
                  <Row gutter={16} align="top">
                    <Col span={24} className="mb-20">
                      <Typography.Text strong>
                        To: <a href="">Coolkaru Info Solutions Pvt Ltd</a>
                      </Typography.Text>
                    </Col>
                    <Col xs={24} sm={4}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.BillingAddress" />
                      </Typography.Text>
                      <p>
                        Ultra tech st, Apt 12A, Laval, Quebec, Canada, A2A 2A2
                      </p>
                    </Col>
                    <Col xs={24} sm={4}>
                      <>
                        <Typography.Text strong>
                          <FormattedMessage id="AddEstimate.ShippingAddress" />
                        </Typography.Text>
                        <p>
                          Ultra tech st, Apt 12A, Laval, Quebec, Canada, A2A 2A2
                        </p>
                      </>
                    </Col>

                    <Col xs={24} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.EstimateDate" />
                      </Typography.Text>
                      <p>2025-07-03</p>
                    </Col>

                    <Col xs={24} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.ExpiryDate" />
                      </Typography.Text>
                      <p>2025-08-03</p>
                    </Col>

                    <Col xs={24} sm={3}>
                      <Typography.Text strong>WO #</Typography.Text>
                      <p>WO1234</p>
                    </Col>
                  </Row>

                  <Table
                    bordered
                    dataSource={dataSource}
                    pagination={false}
                    className="mt-20"
                    summary={() => (
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={5} className="text-right">
                          <b>TOTAL</b>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell align="right">
                          <b>$1945.00</b>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    )}
                  >
                    <Column
                      title="Product name"
                      dataIndex="productName"
                      key="productName"
                    />
                    <Column
                      title="Description"
                      dataIndex="description"
                      key="description"
                    />
                    <Column
                      title="Quantity"
                      dataIndex="quantity"
                      key="quantity"
                      align="right"
                    />
                    <Column
                      title="Unit price"
                      dataIndex="unitPrice"
                      key="unitPrice"
                      align="right"
                    />
                    <Column
                      title="Discount"
                      dataIndex="discount"
                      key="discount"
                      align="right"
                    />
                    <Column
                      title="Amount"
                      dataIndex="amount"
                      key="amount"
                      align="right"
                    />
                  </Table>

                  <Row gutter={32} justify="end" className="mt-20">
                    <Col xs={24} sm={12} md={14}>
                      <Row gutter={16}>
                        <Col xs={24} sm={24}>
                          <Typography.Text strong>
                            <FormattedMessage id="AddEstimate.Notes" />
                          </Typography.Text>
                          <p style={{ whiteSpace: "pre-wrap" }}>
                            Preventive maintenance completed on electrical
                            panels and generators. All connections tightened,
                            components cleaned, and systems tested for proper
                            operation. Performed load test on generator,
                            inspected oil and coolant levels, and verified
                            automatic transfer switch functionality. No issues
                            found.
                          </p>
                        </Col>
                        {/* <Col xs={24} sm={12}>
                      <Form.Item
                        label={
                          <FormattedMessage id="AddEstimate.TermsAndConditions" />
                        }
                        name="termsAndConditions"
                        initialValue={selectedCompany?.termsAndConditions}
                      >
                        <ReactQuill
                          theme="snow"
                          value={form.getFieldValue("termsAndConditions")}
                          onChange={(value) => {
                            form.setFieldsValue({
                              termsAndConditions: value,
                            });
                          }}
                          style={{ height: "120px" }}
                        />
                      </Form.Item>
                    </Col> */}
                      </Row>
                    </Col>
                    <Col xs={24} sm={12} md={10}>
                      <Table
                        bordered
                        showHeader={false}
                        columns={totalColumns}
                        dataSource={data}
                        pagination={false}
                        rowClassName={(record) =>
                          record.className === "total-row" ? "bold-text" : ""
                        }
                      />
                    </Col>
                  </Row>

                  <Col xs={24} sm={24} className="mt-20">
                    <Typography.Text strong>
                      <FormattedMessage id="AddEstimate.TermsAndConditions" />
                    </Typography.Text>
                    <div className="quote-quill">
                      {selectedCompany?.termsAndConditions &&
                        !isQuillContentEmpty(
                          selectedCompany.termsAndConditions
                        ) && (
                          <>
                            <div
                              className={`clamped-content ${
                                expanded ? "expanded" : ""
                              }`}
                              dangerouslySetInnerHTML={{
                                __html: selectedCompany.termsAndConditions,
                              }}
                            />
                            <span
                              className="toggle-link"
                              onClick={toggleExpanded}
                            >
                              {expanded ? "Read less" : "Read more"}
                            </span>
                          </>
                        )}
                    </div>
                  </Col>

                  {/* <Row gutter={32} className="mt-20">
                <Col className="text-Center">
                  <Button danger variant="outlined" size="medium">
                    <CloseCircleOutlined />
                    {<FormattedMessage id="AddEstimate.Cancel" />}
                  </Button>
                </Col>
              </Row> */}
                </Card>
              </Form>
              {isAddressModalOpen && (
                <QuoteAddress
                  billingAddress={billingAddress}
                  shippingAddress={shippingAddress}
                  setBillingAddress={setBillingAddress}
                  setShippingAddress={setShippingAddress}
                  onCancel={() => setIsAddressModalOpen(false)}
                  addressType={addressType}
                />
              )}
            </Col>
            <Col span={6} className="custom-card-new">
              <Card>
                <div className="status-bar">
                  <div className="step completed">
                    <CheckOutlined />
                    <span>Created</span>
                  </div>
                  <div className="line"></div>
                  <div className="step pending">
                    <CheckOutlined />
                    <span>Sent</span>
                  </div>

                  <div className="line"></div>
                  <div className="step pending">
                    <div className="circle"></div>
                    <span>Paid</span>
                  </div>
                </div>
                <div className="card-new-body">
                  <Row gutter={24} justify="space-between">
                    <Col>
                      <div>
                        <Text style={{ fontSize: 13, color: "#555" }}>
                          Amount Paid
                        </Text>
                        <br />
                        <Text strong style={{ fontSize: 16 }}>
                          $2000.00
                        </Text>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-right">
                        <Text style={{ fontSize: 13, color: "#555" }}>
                          Amount Outstanding
                        </Text>
                        <br />
                        <Text strong style={{ fontSize: 16, color: "#000" }}>
                          $490.00
                        </Text>
                      </div>
                    </Col>

                    <Col span="24" className="mt-20">
                      <Button
                        type="primary"
                        block
                        onClick={showRecordPaymentModal}
                      >
                        <FormattedMessage id="Invoice.RecordPayment" />
                      </Button>

                      <p className="mt-10">
                        <a
                          onClick={() => setIsPaymentModalOpen(true)}
                          style={{ cursor: "pointer" }}
                        >
                          1 payment
                        </a>{" "}
                        on June 17, 2025
                      </p>
                    </Col>
                  </Row>
                </div>
              </Card>
              <Card className="mt-10">
                <div className="card-new-body">
                  <Row gutter={[8]} className="viewinvoicebuttons">
                    <Col span={12}>
                      <Button color="default" variant="link" block>
                        <EyeFilled />
                        <FormattedMessage id="ViewQuote.Preview" />
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button color="default" variant="link" block>
                        <PaperClipOutlined />
                        <FormattedMessage id="ViewQuote.Files" />
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button color="default" variant="link" block>
                        <EditFilled />
                        Edit Invoice
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button color="default" variant="link" block>
                        <MessageFilled />
                        Email
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button color="default" variant="link" block>
                        <DownloadOutlined />
                        Download
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button color="default" variant="link" block>
                        <FileFilled />
                        Copy
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card>
            </Col>
          </Row>
          <Modal
            title="Refund Amount"
            open={isRefundModalVisible}
            onOk={handleRefundSubmit}
            onCancel={closeRefundModal}
            okText="Refund"
            cancelText="Cancel"
            confirmLoading={isRefundProcessing}
            destroyOnClose
          >
            <Form
              form={refundForm}
              layout="horizontal"
              labelCol={{ flex: "0 0 30%" }}
              wrapperCol={{ flex: "0 0 70%" }}
              labelAlign="left"
              colon={false}
              name="refundAmountForm"
            >
              <Form.Item
                label="Refund Amount"
                name="amount"
                rules={[
                  { required: true, message: "Please enter the refund amount" },
                  {
                    type: "number",
                    min: 0.01,
                    message: "Amount must be positive",
                  },
                ]}
              >
                <Input
                  type="number"
                  prefix="$"
                  placeholder="Enter refund amount"
                />
              </Form.Item>

              <Form.Item
                label="Refund Notes"
                name="notes"
                rules={[{ max: 250, message: "Maximum 250 characters" }]}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Reason for refund (optional)"
                />
              </Form.Item>
              <Form.Item label="Method" name="method">
                <Input placeholder="Enter a method" />
              </Form.Item>
              <Form.Item label="Reference (optional)" name="reference">
                <Input placeholder="Reference" />
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            title={<FormattedMessage id="Invoice.RecordPayment" />}
            open={isRecordPaymentModalVisible}
            onOk={handleRecordPaymentOk}
            onCancel={handleRecordPaymentCancel}
            footer={null}
          >
            <Tabs
              defaultActiveKey="1"
              centered
              onChange={handleTabChange}
              className="mt-10"
            >
              <Tabs.Item tab="Log Received Amount" key="1">
                <Form
                  layout="horizontal"
                  className="viewinvoice-newitem"
                  form={form}
                  labelCol={{ flex: "0 0 50%" }}
                  wrapperCol={{ flex: "0 0 50%" }}
                  labelAlign="left"
                  colon={false}
                >
                  <Card className="clientview-new">
                    <Form.Item label="Outstanding amount" name="outstanding">
                      <Input disabled />
                    </Form.Item>
                    <Form.Item label="Amount received" name="amountReceived">
                      <Input />
                    </Form.Item>
                    <Form.Item label="Discount" name="discount">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="New outstanding amount"
                      name="newOutstanding"
                    >
                      <Input disabled />
                    </Form.Item>
                  </Card>

                  <Card className="clientview-new mt-10">
                    <Form.Item label="Payment date" name="paymentDate">
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="Paid into" name="paidInto">
                      <Select placeholder="Please select">
                        <Option value="bank">Bank</Option>
                        <Option value="cash">Cash</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item label="Method" name="method">
                      <Input placeholder="Enter a method" />
                    </Form.Item>
                    <Form.Item label="Reference (optional)" name="reference">
                      <Input placeholder="Reference" />
                    </Form.Item>
                  </Card>
                  <div
                    className="mt-15"
                    style={{ justifyContent: "flex-end", display: "flex" }}
                  >
                    <Space>
                      <Button key="cancel" onClick={handleRecordPaymentCancel}>
                        Cancel
                      </Button>

                      <Button
                        key="submit"
                        type="primary"
                        onClick={handleRecordPaymentOk}
                        style={{ background: "#1e9e5e" }}
                      >
                        Record ${form.getFieldValue("amountReceived") || "0.00"}
                      </Button>
                    </Space>
                  </div>
                </Form>
              </Tabs.Item>
              <Tabs.Item tab="Refund Payment" key="2">
                <Form
                  form={refundForm}
                  layout="horizontal"
                  className="viewinvoice-newitem"
                  labelCol={{ flex: "0 0 40%" }}
                  wrapperCol={{ flex: "0 0 60%" }}
                  labelAlign="left"
                  colon={false}
                  name="refundAmountForm"
                >
                  <Card className="clientview-new">
                    <Form.Item
                      label="Refund Amount"
                      name="amount"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the refund amount",
                        },
                        {
                          type: "number",
                          min: 0.01,
                          message: "Amount must be positive",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        prefix="$"
                        placeholder="Enter refund amount"
                      />
                    </Form.Item>
                    <Form.Item label="Payment date" name="paymentDate">
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                    <Form.Item label="Paid into" name="paidInto">
                      <Select placeholder="Please select">
                        <Option value="bank">Bank</Option>
                        <Option value="cash">Cash</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item label="Method" name="method">
                      <Input placeholder="Enter a method" />
                    </Form.Item>
                    <Form.Item label="Reference (optional)" name="reference">
                      <Input placeholder="Reference" />
                    </Form.Item>
                    <Form.Item
                      label="Refund Notes"
                      name="notes"
                      rules={[{ max: 250, message: "Maximum 250 characters" }]}
                    >
                      <Input.TextArea
                        rows={3}
                        placeholder="Reason for refund (optional)"
                      />
                    </Form.Item>
                  </Card>
                  <div
                    className="mt-15"
                    style={{ justifyContent: "flex-end", display: "flex" }}
                  >
                    <Space>
                      <Button key="cancel" onClick={handleRecordPaymentCancel}>
                        Cancel
                      </Button>

                      <Button
                        key="submit"
                        type="primary"
                        onClick={handleRecordPaymentOk}
                        style={{ background: "#1e9e5e" }}
                      >
                        Refund
                      </Button>
                    </Space>
                  </div>
                </Form>
              </Tabs.Item>
            </Tabs>
          </Modal>

          <Modal
            title="Payments and Allocations"
            open={isPaymentModalOpen}
            onCancel={() => setIsPaymentModalOpen(false)}
            footer={null}
            width={900}
          >
            <p>A detailed breakdown of payments and refunds.</p>
            <Table
              className="mt-10"
              columns={columns1}
              dataSource={data1}
              pagination={false}
              bordered
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={3}>
                    Total
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3}>2000.00</Table.Summary.Cell>
                  <Table.Summary.Cell index={4}>0.00</Table.Summary.Cell>
                  <Table.Summary.Cell index={5}>2000.00</Table.Summary.Cell>
                  <Table.Summary.Cell index={5}></Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
            <Row justify="end">
              <Col sm={24} md={12} lg={6}>
                <div style={{ marginTop: 20 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>Total Invoice</strong>
                    <span>
                      <strong>$2490.00</strong>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>Paid Total</strong>
                    <span>
                      <strong>$2000.00</strong>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>Redund Total</strong>
                    <span>
                      <strong>$2000.00</strong>
                    </span>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <strong>Outstanding</strong>
                    <span>
                      <strong>$490.00</strong>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default ViewInvoice;
